import { defaultConfig } from '@/cms/api/ApiConfig';
import store from '@/store/store';
import AxiosService from './axiosService';
import { isDevelop } from './environmentService';
import TestConfig from '@/views/digitalAccept/TestData/TestData';
import { createDigitalAcceptSubmitRequest } from './acceptSubmitService';
import { ConsentResponse } from '@/types/types';
import { createConsentBody } from './consentService';
import { Log } from '@/appinsights/logging/log';

// KLK ERROR Submit
export const getProposal = async (receipt = false) => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
	const axiosService = new AxiosService();
	let proposal: any;

	try {
		const url = baseUrl + proposeUrl;
		proposal = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load proposal', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	if (proposal?.status !== 200 && isDevelop) {
		console.warn('fallback DEV load HardCoded proposal');
		// proposal = receipt ? TestConfig.getReceiptHardCoded() : TestConfig.getMock();
		proposal = TestConfig.getMock();
	}
	if (proposal?.status !== 200) {
		if (proposal?.status === 400 && proposal?.data?.detail) {
			store.state.errorMessage = proposal.data.detail;
		}
	}

	return proposal;
};

// KLK ERROR Submit
export const getInsuranceCompanies = async () => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/insurance-companies`;
	const axiosService = new AxiosService();
	let proposal: any;

	try {
		const url = baseUrl + proposeUrl;
		proposal = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load insurance companies', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	return proposal;
};
// KLK ERROR Submit
export const submitProposal = async () => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const proposeUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
	const axiosService = new AxiosService();
	const url = baseUrl + proposeUrl;
	const proposalRes = await axiosService.patch(url, createDigitalAcceptSubmitRequest());
	return proposalRes;
};

// KLK ERROR Submit
export const getConsent = async (): Promise<{ data: ConsentResponse; status: any }> => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const consentUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}/consents
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;

	const axiosService = new AxiosService();
	let consentResponse: any;

	try {
		const url = baseUrl + consentUrl;
		consentResponse = await axiosService.get(url);
	} catch (e) {
		Log.exception('cannot load consent', e, { quoteId: store.state.ProposalContext.quote_id });
	}

	if (consentResponse?.status !== 200 && isDevelop) {
		console.warn('fallback DEV load HardCoded consent');
		consentResponse = TestConfig.getPolicyConsentHardCoded();
	}
	// KLK perhaps popup with load error and ask user to try again later or call us?
	return consentResponse;
};

// KLK ERROR Submit
export const submitConsent = async () => {
	const baseUrl = defaultConfig.baseUrl + store.state.proxyUrl;
	const consentUrl = `/quote-accept/quote/${store.state.ProposalContext.quote_id}/consents
		?customer_no=${store.state.ProposalContext.customerNo}&signature=${store.state.ProposalContext.signatureId}&timestamp=${store.state.ProposalContext.timestamp}`;
	const axiosService = new AxiosService();
	const url = baseUrl + consentUrl;
	const consentRes = await axiosService.put(url, createConsentBody());
	return consentRes;
};
